import React, { useState, useEffect } from "react";
import LeftIndent from "utils/LeftIndent";
import ConfigTabs from "../ConfigTabs";
import { Tab, Nav, Container, Form } from "react-bootstrap";
import Basic from "./basic_info_cu/Basic";
import Website from "./website_permissions/Website";
import Team from "./team_access/Team";
import Services from "./services_agreement/Services";
import SaveChanges from "client_config/SaveChanges";
import updateParams from "utils/updateParams.js";

export default function AccountConfig(props) {
  const [tabLocation, setTabLocation] = useState("");
  const [formAction, setFormAction] = useState({});
  const formSubmitUrl = "/datapulse/account-config";
  const authenticityToken = document.querySelector('meta[name="csrf-token"]').content;

  const [isPpcEnabled, setIsPpcEnabled] = useState(
    props.search_section.enabled || props.social_section.enabled || props.display_section.enabled || props.video_section.enabled
  );
  const [isSeoEnabled, setIsSeoEnabled] = useState(props.seo_section.enabled ? true : false);

  const servicePicker = (searchParams) => {
    if (searchParams.toString().includes("seo")) {
      return "seo"
    }
    if (searchParams.toString().includes("ppc")) {
      return "ppc"
    }

    if (isPpcEnabled) {
      return "ppc"
    }
    else if (isSeoEnabled) {
      return "seo"
    }
  }
  
  useEffect(() => {
    let searchParams = new URL(location.href).searchParams;
    let page = searchParams.get("page");
    if (!page || page == "") {
      page = "basic";
    }
    if (page === "services") {
      setTabLocation(page);
      updateParams("page", page);
      updateParams("sub_page", servicePicker(searchParams));
    }
    else {
    setTabLocation(page);
    updateParams("page", page);
    }
  }, []);

  const selectTab = (key) => {
    let searchParams = new URL(location.href).searchParams;
    if (key === "services") {
      setTabLocation(key);
      updateParams("page", key);
      updateParams("sub_page", servicePicker(searchParams));
    }
    else {

      setTabLocation(key);
      updateParams("page", key);
    }
  };

  return (
    <>
      <ConfigTabs className="m-0 p-0" enabledServices={props.enabled_services} selectedTab="account" />
      <LeftIndent>
        <Form id="account-config-form" className="client-config-content" method="post" encType="multipart/form-data" action={formSubmitUrl}>
          <Container fluid style={{ backgroundColor: "#E1E1E1" }}>
            <SaveChanges page={tabLocation}/>
            <input hidden name="selected_page" value={tabLocation} readOnly />
            <input hidden name="client_account_id" value={props.client_account.id} readOnly />
            <input hidden name="authenticity_token" value={authenticityToken} readOnly />
            <Tab.Container id="account-config-tabs" defaultActiveKey="basic" activeKey={tabLocation} onSelect={(k) => selectTab(k)}>
              <Nav variant="pills" className="nav-fill tabs-navigation-2 row no-gutters row-cols-sm-1 row-cols-md-2 row-cols-lg-4 mb-2 mb-lg-0 py-0 px-0 px-lg-5">
                <Nav.Item className="col">
                  <Nav.Link eventKey="basic" className="tab-titles sub-nav-item" data-link-type="page">
                    Basic Info and Client Users
                  </Nav.Link>
                </Nav.Item>
                <Nav.Item className="col">
                  <Nav.Link eventKey="website" className="tab-titles sub-nav-item" data-link-type="page">
                    Website and Permissions
                  </Nav.Link>
                </Nav.Item>
                <Nav.Item className="col">
                  <Nav.Link eventKey="team" data-link-type="page">Team Access</Nav.Link>
                </Nav.Item>
                <Nav.Item className="col">
                  <Nav.Link eventKey={"services"} data-link-type="page" className="tab-titles sub-nav-item">
                    Services and Agreement
                  </Nav.Link>
                </Nav.Item>
              </Nav>
              <Tab.Content>
                <Tab.Pane eventKey="basic">
                  <Basic {...props} />
                </Tab.Pane>
                <Tab.Pane eventKey="website">
                  <Website {...props} />
                </Tab.Pane>
                <Tab.Pane eventKey="team">
                  <Team {...props} />
                </Tab.Pane>
                <Tab.Pane eventKey="services">
                  <Services servicePicker={servicePicker} isPpcEnabled={isPpcEnabled} setIsPpcEnabled={setIsPpcEnabled} isSeoEnabled={isSeoEnabled} {...props} />
                </Tab.Pane>
              </Tab.Content>
            </Tab.Container>
          </Container>
        </Form>
      </LeftIndent>
    </>
  );
}
